<template>
  <el-pagination
    :key="syncKey"
    background
    :layout="layout"
    :page-sizes="pageSizes"
    :page-size="pageSize"
    :current-page="currentPage"
    :total="total"
    @current-change="emitPage"
    @size-change="emitSize" />
</template>

<script>
import { DEFAULT_PAGE_SIZE } from '@/utils/pagedList'

/** 페이지 크기 선택지 — 첫 칸이 기본값이다(계획 결정 9) */
const DEFAULT_PAGE_SIZES = [DEFAULT_PAGE_SIZE, 100, 200, 300]

/**
 * **목록 화면의 페이지 UI 한 곳** — `el-pagination` 을 화면마다 다시 적지 않는다.
 *
 * 0-base(`searchForm.currPage`, 서버)와 1-base(`el-pagination`)의 변환이 이 컴포넌트와
 * `pagedListMixin.handlePageChange` 양쪽 끝에 있다. 화면은 두 벌을 보지 않는다:
 *
 * ```html
 * <list-pagination
 *   :search-form="searchForm"
 *   :total="totalElements"
 *   @page-change="handlePageChange"
 *   @size-change="handleSizeChange" />
 * ```
 */
export default {
  name: 'ListPagination',
  data: function () {
    return {
      /**
       * 한 번 다시 그리게 하는 열쇠 — **거절된 조작을 화면에서 지운다**.
       *
       * `el-pagination` 은 클릭을 받으면 부모에게 알리기 **전에** 자기 안의 쪽 번호·크기를 먼저
       * 바꾼다(`internalCurrentPage`). 그리고 그 값을 `current-page` prop 으로 되돌리는 watcher 는
       * **prop 이 실제로 달라졌을 때만** 돈다. 그래서 부모가 그 조작을 거절하면(전제가 없는 조회 —
       * `pagedListMixin.canSearch`) 아무 일도 일어나지 않았는데 **페이저만 2페이지를 가리킨 채 남는다**.
       *
       * 열쇠를 올리면 `el-pagination` 이 새로 만들어지고, 그때 읽는 prop 은 `searchForm` 이다 —
       * 받아들여진 조작이면 이미 새 값이고(핸들러가 동기로 쓴다), 거절된 조작이면 옛 값이다.
       * 즉 **진실은 언제나 `searchForm` 한 곳**이고 페이저는 그것을 따라 그린다.
       */
      syncKey: 0,
    }
  },
  props: {
    /** 페이징 축을 가진 검색 조건(`utils/pagedList.withPaging`) — 읽기만 한다 */
    searchForm: { type: Object, required: true },
    /** 서버가 말한 전체 행수 */
    total: { type: Number, default: 0 },
    pageSizes: { type: Array, default: () => DEFAULT_PAGE_SIZES.slice() },
    layout: { type: String, default: 'prev, pager, next, jumper, ->, sizes, total' },
  },
  computed: {
    pageSize: function () {
      return this.searchForm.pageSize || DEFAULT_PAGE_SIZE
    },
    /** 서버는 0-base, `el-pagination` 은 1-base 다 */
    currentPage: function () {
      const currPage = this.searchForm.currPage

      return (typeof currPage === 'number' && currPage > 0 ? Math.floor(currPage) : 0) + 1
    },
  },
  methods: {
    /** 쪽 이동을 알리고 **그 답을 다시 그린다** — 부모가 거절했으면 페이저도 제자리로 */
    emitPage: function (page) {
      this.$emit('page-change', page)
      this.syncKey++
    },
    /** 크기 변경도 같다 — 거절된 크기가 셀렉트에만 남지 않게 한다 */
    emitSize: function (size) {
      this.$emit('size-change', size)
      this.syncKey++
    },
  },
}
</script>
